<template>
  <div class="flex column points-possible">
    <div><strong>Points Possible</strong></div>
    <div class="flex row space-between">
      <div class="text">Base Points for {{challengeTypeName}}</div>
      <div>{{basePointsForChallengeType}}</div>
    </div>
    <div class="flex row space-between">
      <div>Difficulty Multiplier</div>
      <div>{{challengeBonusMultiplier}}x</div>
    </div>
    <div class="flex row space-between">
      <div><strong>Total</strong></div>
      <div><strong>{{challegePointsPossibleTotal}}</strong></div>
    </div>
  </div>
</template>

<script>
  import './ChallengePointsPossible.scss';

  export default {
    props: ['challenge'],
    computed: {
      basePointsForChallengeType() {
        return this.challenge ? this.challenge.challenge_type.points_per_challenge_default : 0;
      },
      challengeBonusMultiplier() {
        return this.challenge ? this.challenge.bonus_multiplier : 0;
      },
      challegePointsPossibleTotal() {
        return this.basePointsForChallengeType * this.challengeBonusMultiplier;
      },
      challengeTypeName() {
        return this.challenge ? this.challenge.challenge_type.name : 'N/A';
      }
    }
  };
</script>
